import React from "react";
import { useSelector } from "react-redux";

export default function StudentPosition({ usersPosition }) {
  const user = useSelector((state) => state.auth.user);

  const userPosition = usersPosition?.find((u) => {
    return u.id === user?.id;
  });

  return (
    <div>
      <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr>
            <th className="table-th !text-center">Rank</th>
            <th className="table-th !text-center">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>

        <tbody>
          <tr className="border-2 border-cyan">
            <td className="table-td text-center font-bold">
              {userPosition?.position}
            </td>
            <td className="table-td text-center font-bold">
              {userPosition?.name}
            </td>
            <td className="table-td text-center font-bold">
              {userPosition?.quizMark}
            </td>
            <td className="table-td text-center font-bold">
              {userPosition?.assignmentMark}
            </td>
            <td className="table-td text-center font-bold">
              {userPosition?.totalMark}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
